import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about">
      <div className="about-container">
        <section className="about-hero">
          <div className="about-brand">
            <h1>Chester's</h1>
            <p className="tagline">Chicken on the Run</p>
          </div>
        </section>

        <section className="about-content">
          <div className="about-section">
            <h2>Our Story</h2>
            <p>
              Chester's Chicken has been serving the Springfield, Massachusetts community 
              with delicious, freshly prepared fried chicken. Located at Shamrock Market, 
              we've built our reputation on quality ingredients, authentic recipes, and 
              exceptional customer service.
            </p>
            <p>
              Our mission is simple: to provide the best fried chicken experience possible. 
              Every piece of chicken is prepared with care, using our signature blend of 
              spices and cooking techniques that have made us a local favorite.
            </p>
          </div>

          <div className="about-section">
            <h2>What We Offer</h2>
            <div className="offerings">
              <div className="offering-item">
                <h3>Super Tenders</h3>
                <p>Juicy, tender chicken tenders that are crispy on the outside and perfectly cooked inside.</p>
              </div>
              <div className="offering-item">
                <h3>Bone-In Chicken</h3>
                <p>Classic fried chicken pieces with our special seasoning blend.</p>
              </div>
              <div className="offering-item">
                <h3>Bites & Sandwiches</h3>
                <p>Perfect for a quick meal on the go - chicken bites and our famous fried chicken sandwich.</p>
              </div>
              <div className="offering-item">
                <h3>Party Platters</h3>
                <p>Feed a crowd with our large party platters - perfect for gatherings and events.</p>
              </div>
              <div className="offering-item">
                <h3>Specialty Bowls</h3>
                <p>Try our Buffalo Mac & Cheese Bowl or Chester's Bowl for a unique dining experience.</p>
              </div>
              <div className="offering-item">
                <h3>Samosas</h3>
                <p>Traditional samosas with peas & potatoes, chicken, or lamb fillings.</p>
              </div>
            </div>
          </div>

          <div className="about-section">
            <h2>Our Commitment</h2>
            <p>
              At Chester's Chicken, we're committed to using fresh ingredients and maintaining 
              the highest standards of food quality and safety. We believe that great food brings 
              people together, and we're proud to be part of the Springfield community.
            </p>
            <p>
              Whether you're ordering through our mobile app, calling in, or visiting us in person, 
              we're here to serve you the best chicken experience possible.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;

